import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import Layout from "@ui/components/Layout";
import VehicleDetailWidget from "@ui/widgets/VehicleDetailWidget";
import {queryWorkspace} from "@data/repositories/Workspace/queryWorkspace";

import {
  VehicleDetailScreenContainer,
  GridSpacer,
  ScrollableContent,
} from "./vehicleDetailScreenStyle";
import {ACTIVE} from "@data/constants/entity";

// 遷移用stateの型
type VehicleDetailLocationState = {
  vehicle_id: string;
  alias_name?: string;
  is_active: ACTIVE;
  ver_no: number;
  user_id?: number;
  workspace_cd: string;
  dash_token?: string;
  workspace_m: {
    company_id?: string;
    workspace_nm: string;
  };
};

// 型ガード
// TODO: 厳密には他のプロパティもチェックすべき。それを行うには型定義を見直す必要がある。
const isVehicleDetailLocationState = (
  value: unknown
): value is VehicleDetailLocationState => {
  const v = value as VehicleDetailLocationState | undefined;

  return Boolean(
    v &&
    typeof v.vehicle_id === "string" &&
    typeof v.workspace_m?.workspace_nm === "string"
  );
};

const VehicleDetailScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;

  const {useWorkspaceDropdown} = queryWorkspace();
  const {data, isError} = useWorkspaceDropdown();

  const isValidState = isVehicleDetailLocationState(state);

  // 不正なstateならリダイレクト
  useEffect(() => {
    if (!isValidState) {
      console.error("Invalid location.state", state);
      navigate("/vehicles", {replace: true});
    }
  }, [isValidState, navigate, state]);

  // APIエラー用
  useEffect(() => {
    if (isError) {
      alert("データの取得に失敗しました");
      return;
    }
  }, [isError]);

  // ガード
  if (!isValidState) {
    return <div>不正な遷移です</div>;
  }

  const vehicle = state;

  return (
    <Layout title="車両：走行環境切替">
      <VehicleDetailScreenContainer>
        <GridSpacer/>
        <ScrollableContent>
          <VehicleDetailWidget
            workspaces={data}
            vehicle={vehicle}
            currentWorkspace={{
              workspace_nm: vehicle.workspace_m.workspace_nm,
            }}
          />
        </ScrollableContent>
      </VehicleDetailScreenContainer>
    </Layout>
  );
};

export default VehicleDetailScreen;
